/**
 * DatePickerButton
 */
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import moment from 'moment';

// Workspaces
import { selectFirstDate, selectLastDate } from '../../../../selectors';

// Styles
import './styles.scss';

interface Props {
    onClick: Function;
    firstDate: string;
    lastDate: string;
}

export class DatePickerButton extends React.PureComponent<Props> {
    render() {
        const { onClick, firstDate, lastDate } = this.props;
        return (
            <button
                className="date-picker-button"
                onClick={onClick}
                type="button"
            >
                {moment(firstDate, 'YYYY-MM-DD').format('D MMM YYYY')}
                {' - '}
                {moment(lastDate, 'YYYY-MM-DD').format('D MMM YYYY')}
            </button>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    firstDate: selectFirstDate,
    lastDate: selectLastDate
});

export default connect(mapStateToProps)(DatePickerButton);
